/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Xóa mục đã chọn',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Không thể truy xuất dữ liệu',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Nhấp vào để thử lại',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Đang tải...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Hiển thị thêm',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Không tìm thấy kết quả phù hợp nào',
  'paginated-picker.async-select.select.option.error-message': 'Không thể truy xuất dữ liệu',
  'paginated-picker.async-select.select.option.retry-message': 'Nhấp vào để thử lại',
  'paginated-picker.async-select.select.search-placeholder': 'Tìm kiếm',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Hiển thị danh sách đầy đủ'
};